import { render, staticRenderFns } from "./FunInput.vue?vue&type=template&id=2dc54916&"
import script from "./FunInput.vue?vue&type=script&lang=js&"
export * from "./FunInput.vue?vue&type=script&lang=js&"
import style0 from "./FunInput.vue?vue&type=style&index=0&id=2dc54916&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports